<div class="user-info-container">
  <div class="header">
    <div class="title">
      User Information
    </div>
    <div class="close-btn" (click)="onClickCancel()">
      <i class="fa-solid fa-xmark"></i>
    </div>
  </div>
  <div class="body" [formGroup]="userDetails">
    <div class="users-wing">
      <div class="title">
        Users
      </div>
      <div class="details">
        <div class="name">
          <!-- <p-dropdown [options]="title"></p-dropdown> -->
          <input type="text" readonly class="name-title" formControlName="title"  pInputText placeholder="first name">
          <input type="text" readonly formControlName="firstName" class="first-name" pInputText placeholder="first name">
          <input type="text" readonly formControlName="lastName" class="last-name" pInputText placeholder="last name">
        </div>
        <div class="gender-dob">
          <input type="text" readonly formControlName="gender" placeholder="gender">
          <input type="text" readonly formControlName="dob" placeholder="date of birth">
        </div>
        <input name="institue" readonly class="full-input" formControlName="institution" autocomplete="off" type="text" pInputText placeholder="name of institutions">
        <input name="qualification" readonly class="full-input" formControlName="qualification" autocomplete="off" type="text" pInputText placeholder="qualifications">
        <input name="email" readonly class="full-input" formControlName="email" autocomplete="off" type="email" id="email" pInputText placeholder="e-mail">
      </div>
    </div>
    <div class="contact-wing">
      <div class="title">
        Contact
      </div>
      <div class="details">
        <textarea name="address" readonly formControlName="address" class="full-input" id="" cols="30" rows="4" placeholder="address for communication"></textarea>
        <div class="state-pincode">
          <input name="state" readonly formControlName="state" autocomplete="off" type="text" pInputText placeholder="pincode">
          <input name="pincode" readonly formControlName="pincode" autocomplete="off" type="text" pInputText placeholder="pincode">
        </div>
        <input name="country" readonly class="full-input" formControlName="country" autocomplete="off" type="text" pInputText placeholder="country">
        <div class="mobile">
          <input name="code" readonly formControlName="countryCode" class="code" pInputText autocomplete="off" type="text" placeholder="code">
          <input name="number" readonly formControlName="phone" autocomplete="off" class="number" pInputText type="text" placeholder="phone number">
        </div>
      </div>
    </div>
  </div>
</div>